import React from "react";
import "./index.css"
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { Navbar,Nav } from 'react-bootstrap';
import AboutMe from './components/routes/aboutMe/AboutMe';
import Home from './components/routes/home/Home';
import Cv from './components/routes/cv/Cv';
import NerdArea from './components/routes/nerdArea/NerdArea';
import ContactMe from './components/routes/contactMe/ContactMe';
import BlogCreateEntrance from './components/components/blog/BlogCreateEntrance';
import BlogList from './components/components/blog/BlogList';
import BlogAdmin from './components/components/blog/BlogAdmin';
import Blog from './components/components/blog/Blog';

class App extends React.Component{
    render(){
        return(
            <div>
                <div className="row">
                    <div className="col-md-12">
                        <Router>
                            <Navbar bg="dark" variant="dark" expand="lg" sticky="top">
                                <Navbar.Brand href="/">Daniel Pérez Lorenzo</Navbar.Brand>
                                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                                <Navbar.Collapse id="basic-navbar-nav">
                                    <Nav className="mr-auto">
                                        <Nav.Link href="/">Home</Nav.Link>                
                                        <Nav.Link href="/about-me">About me</Nav.Link>
                                        <Nav.Link href="/cv">CV</Nav.Link>
                                        <Nav.Link href="/nerd-area">Nerd area</Nav.Link>

                                        <Nav.Link href="/contact-me">Contact me</Nav.Link>                                      
                                    </Nav>
                                </Navbar.Collapse>
                            </Navbar>
                            <Switch>
                                <Route exact path ='/about-me'  component={AboutMe} />
                                <Route exact path ='/'  component={Home} />
                                <Route exact path ='/cv'  component={Cv} />
                                <Route exact path ='/nerd-area'  component={NerdArea} />
                                <Route exact path ='/nerd-area/tictactoe'  component={NerdArea} />
                                <Route exact path ='/contact-me'  component={ContactMe} />
                                <Route exact path ='/blog-create'  component={BlogCreateEntrance} />
                                <Route exact path ='/blog-list'  component={BlogList} />
                                <Route exact path ='/blog-admin'  component={BlogAdmin} />
                                <Route exact path ='/blog'  component={Blog} />
                            </Switch>
                        </Router>
                    </div>
                </div>  
            </div>
        )  
    }
}

export default App;
